import {
  PaymentExecutionOptions,
  PaymentExecutionState,
  PaymentMethod,
} from './typing';
import executePayment from './executePayment';
import { useContext, useMemo } from 'react';
import PaymentClientContext from './context/PaymentClientContext';

type PaymentExecuteFn = (
  method: PaymentMethod,
  args?: Record<string, any>,
  options?: PaymentExecutionOptions,
) => Promise<PaymentExecutionState>;

interface UsePaymentExecutionType {
  execute: PaymentExecuteFn;
}
function usePaymentExecution(orderId: string): UsePaymentExecutionType {
  const { defaultOptions: defaultOptionsFn } = useContext(PaymentClientContext);
  return useMemo(() => {
    return {
      execute: (method, args = {}, options?: PaymentExecutionOptions) => {
        const defaultOptions = defaultOptionsFn(method);
        options = Object.assign(defaultOptions, options);
        return executePayment(orderId, method, args, options);
      },
    };
  }, [defaultOptionsFn, orderId]);
}

export default usePaymentExecution;
